import { Heading } from '@treams/treams-ui';

export default function ReviewGoals() {
	return <Heading>Review goals</Heading>;
}
